import { LIGHT_THEME_CLASS } from '@locaveri/ui'
import { createContext, useContext } from 'react'

/**
 * Dark é o tema PADRÃO do produto (CLAUDE.md). O documento em estado base não
 * leva classe nenhuma; é a classe `light` — a mesma que `theme.css` observa —
 * que liga o tema claro. Por isso não existe classe "dark" em lugar algum.
 */
export type Tema = 'dark' | 'light'

export const TEMA_PADRAO: Tema = 'dark'

/** Chave do localStorage. Prefixada para não colidir com outro app no host. */
export const TEMA_STORAGE_KEY = 'locaveri:admin:tema'

export interface ThemeContextValue {
  readonly tema: Tema
  readonly definirTema: (tema: Tema) => void
  readonly alternarTema: () => void
}

export const ThemeContext = createContext<ThemeContextValue | null>(null)

export function useTheme(): ThemeContextValue {
  const value = useContext(ThemeContext)

  if (value === null) {
    throw new Error('useTheme() precisa estar dentro de <ThemeProvider>.')
  }

  return value
}

function ehTema(value: string | null): value is Tema {
  return value === 'dark' || value === 'light'
}

/**
 * Lê a preferência salva. Sem preferência (ou com localStorage bloqueado, o
 * que acontece em navegação privativa), o tema é o escuro.
 */
export function lerTemaSalvo(): Tema {
  try {
    const salvo = window.localStorage.getItem(TEMA_STORAGE_KEY)
    return ehTema(salvo) ? salvo : TEMA_PADRAO
  } catch {
    return TEMA_PADRAO
  }
}

export function salvarTema(tema: Tema): void {
  try {
    window.localStorage.setItem(TEMA_STORAGE_KEY, tema)
  } catch {
    // Sem persistência disponível o tema continua valendo para esta aba.
  }
}

/** Aplica (ou remove) a classe `light` na raiz do documento. */
export function aplicarTema(tema: Tema): void {
  document.documentElement.classList.toggle(LIGHT_THEME_CLASS, tema === 'light')
}
